<template>
  <div>
    <div
      style="width: calc(100vw - 36px);"
      :class="[
        'tw-fixed tw-z-40 tw-h-screen tw-right-0 tw-top-0 transition-slow tw-bg-white side-nav-right tw-overflow-auto',
        { 'side-nav--open tw-shadow-xl': openNav},
      ]"
    >
      <div class="tw-z-20 tw-w-full tw-sticky tw-top-0">
        <TopNav
          :title="rightSideNavTitle"
          center-title
          always-center
          title-class="tw-uppercase tw-font-bold tw-text-center"
          :show-notification-icon="false"
          :show-user-photo="false"
        >
          <button
            slot="left-action"
            class="top-nav__action tw-ml-4"
            @click.prevent="close()"
            >
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 72 72" style="enable-background:new 0 0 72 72;" xml:space="preserve">
                <path d="M56,4.2c0,1.2-0.4,2-1.2,2.9l-29,29l29,29c1.6,1.6,1.6,4.1,0,5.7s-4.1,1.6-5.7,0L17.2,39c-1.6-1.6-1.6-4.1,0-5.7l31.9-32
                  c1.6-1.6,4.1-1.6,5.7,0C55.6,2.1,56,3,56,4.2z"/>
              </svg>
              <span class="tw-uppercase tw-align-middle">close</span>
          </button>
        </TopNav>
      </div>
      <div class="tw-h-6"></div>
      <transition name="fade-delay" mode="out-in" appear>
        <portal-target
          name="right-side-nav"
          v-if="!disablePortal"
          @close="close()"
        />
        <slot name="default" v-else />
      </transition>
      <slot name="trigger" />
    </div>
    <transition name="fade" appear>
      <div
        v-show="openNav"
        @click="close()"
        class="tw-fixed tw-w-screen tw-h-screen tw-bg-transparent tw-opacity-0 tw-z-30 tw-left-0 tw-top-0"
      ></div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'RightSideNav',
  props: {
    disablePortal: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      rightSideNavTitle: state => state.ui.rightSideNavTitle,
      openNav: state => state.ui.openRightSideNav,
    }),
  },
  methods: {
    close() {
      this.$store.commit('closeRightSideNav');
      this.$store.commit('showNotifications', false);
    },
  },
};
</script>

<style>
</style>
